"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Constant = void 0;
var Constant = {
  SuccessMessageForSaving: 'Your changes have been saved.',
  ErrorMessageFromServer: 'Bad response from server.',
  APIFailureMessage: 'Something went wrong.',
  DateTimeFormat: {
    shortDate: 'MM/DD/YYYY',
    shortTime: 'HH:mm',
    shortTimeAMPM: 'hh:mm A',
    longTimeAMPM: 'hh:mm AA',
    shortDayOfWeek: 'ddd',
    dayOfWeek: 'dddd',
    shortMonth: 'MMMM YYYY',
    // date time format with AM PM
    dateTimeAMPM: 'MM/DD/YYYY hh:mm A',
    dateTimeShortYearAMPM: 'MM/DD/YY hh:mm A',
    longDateFormat: 'MMMM DD, YYYY',
    longDayOfWeekFormat: 'dddd, MMMM DD, YYYY',
    longDateTimeFormat: 'MMMM DD, YYYY hh:mm A',
    // Short date, year
    shortYear: 'MM/DD/YY',
    defaultSurveyDate: 'YYYY-MM-DD',
    defaultSurveyDateTime: 'YYYY-MM-DDTHH:mm'
  },
  LANGUAGE_PREFERENCES: [{
    value: 'es',
    label: 'Spanish'
  }, {
    value: 'en',
    label: 'English'
  }],
  DateTimePattern: {
    /**
     * Prospect's DOB need to be supported by below formats:
     * MM/DD/YYYY, MM/D/YYYY, M/DD/YYYY, M/D/YYYY
     * MM-DD-YYYY, MM-D-YYYY, M-DD-YYYY, M-D-YYYY
     * MM/DD/YY, MM/D/YY, M/DD/YY, M/D/YY
     * MM-DD-YY, MM-D-YY, M-DD-YY, M-D-YY
     */
    DOB: /^((\d{1,2}(-)\d{1,2}(-))|(\d{1,2}(\/)\d{1,2}(\/)))(\d{2}|\d{4})$/
  },
  getAppName: function getAppName() {
    return window.env && window.env.APP_NAME || 'Program Management Toolkit';
  }
};
// export Constants component
exports.Constant = Constant;
var _default = Constant;
exports.default = _default;